<template>
  <qx-card title="费用报销">
    <!--    <qx-img-dialog ref="imgDialog" />-->
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
          >
            <section slot-scope="scope">
              <section>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
      searchBoxData: {
        sourceOfGoodsId: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: '', label: '补轮胎支出'},
          {prop: '', label: '电路类支出'},
          {prop: '', label: '车灯类支出'},
          {prop: '', label: '车辆维修设备换件支出'},
          {prop: '', label: '电焊修补支出'},
          {prop: '', label: '打黄油'},
          {prop: '', label: '换新轮胎支出'},
          {prop: '', label: '柴暖类支出'},
          {prop: '', label: '合计维修费用'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    // getList: getReceiptRecordList,
  },
  // created() {
  //   this.searchBoxData.orderId=this.orderId||this.$route.query.id
  //   this.getData()
  // }
};
</script>

<style scoped>

</style>
